import { render, staticRenderFns } from "./ListProjects.vue?vue&type=template&id=1c3897a4&scoped=true&lang=html&"
import script from "./ListProjects.vue?vue&type=script&lang=js&"
export * from "./ListProjects.vue?vue&type=script&lang=js&"
import style0 from "./ListProjects.vue?vue&type=style&index=0&id=1c3897a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c3897a4",
  null
  
)

export default component.exports